import gql from 'graphql-tag';

export const GET_ACCOUNT_LEAD_OPTIONS = gql`
  query GetAccountLeads {
    leadOptions: accountLeads {
      value: id
      businessName
      contact: fullName
      email
      createdDateTime
    }
  }
`;
